import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import { useEffect, useRef } from "react";
import { useAppSelector } from "store/hooks";

type SourceFieldProps = {
  name: string;
  value: string;
  onChange: (value: any) => void;
};

const SourceField = (props: SourceFieldProps) => {
  const inputRef = useRef<HTMLElement | null>(null);

  const selectedRoute = useAppSelector(
    (state) => state.developer.edit.editor.selectedRoute
  );

  useEffect(() => {
    if (selectedRoute) {
      inputRef.current && inputRef.current.focus();
    }
  }, [selectedRoute]);

  return (
    <EditorVisualTextField
      label="Resource Name/URL"
      size="small"
      fullWidth
      inputRef={inputRef}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    />
  );
};

export default SourceField;
